import type { C360Interaction } from "../api/interactions";

import { useC360InteractionStore } from "./useC360InteractionStore";

/** The interaction only when both IDs are present, since the eligibility API takes them as a pair. */
export function withBothC360Ids(interaction: C360Interaction | undefined): C360Interaction | undefined {
    return interaction?.interactionId && interaction.interactionLineId ? interaction : undefined;
}

export const useC360InteractionIds = (sessionId: string): C360Interaction | undefined =>
    useC360InteractionStore((state) => withBothC360Ids(state.sessions[sessionId]));

export const getC360InteractionIds = (sessionId: string): C360Interaction | undefined =>
    withBothC360Ids(useC360InteractionStore.getState().getInteraction(sessionId));
